import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Icon from '@material-ui/core/Icon';
import { MdLabel, MdTrendingFlat } from 'react-icons/md';
import { AiFillClockCircle } from 'react-icons/ai';
import { IoMdVideocam } from 'react-icons/io';

import {
  Container,
  Content,
  DrugTitle,
  Detail,
  VideoButton,
  DetailText,
} from './styles';

function DrugItem({ item }) {
  const {
    days,
    recommendation,
    drug: { factor, manufacturer, video_url },
  } = item;

  const ptDays = ['Dom.', 'Seg.', 'Ter.', 'Qua.', 'Qui.', 'Sex.', 'Sáb.'];

  const daysParsed = useMemo(() => {
    return days ? days.split(',').map((day) => ptDays[day]) : null;
  }, [days, ptDays]);

  function playVideo(videoId) {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  }

  return (
    <Container>
      <Icon className="icon-infusion-kit" />

      <Content>
        <DrugTitle>{factor}</DrugTitle>

        <Detail>
          <MdLabel />
          <DetailText>{manufacturer}</DetailText>
        </Detail>

        {days && (
          <Detail>
            <AiFillClockCircle />
            <DetailText>{daysParsed.join(' ')}</DetailText>
          </Detail>
        )}

        {recommendation && (
          <Detail>
            <MdTrendingFlat />
            <DetailText>{recommendation}</DetailText>
          </Detail>
        )}

        {video_url && (
          <VideoButton onClick={() => playVideo(video_url)}>
            <IoMdVideocam size={16} />
            <DetailText bold>Veja como fazer sua infusão</DetailText>
          </VideoButton>
        )}
      </Content>
    </Container>
  );
}

DrugItem.propTypes = {
  item: PropTypes.shape({
    days: PropTypes.string,
    recommendation: PropTypes.string,
    drug: PropTypes.shape({
      factor: PropTypes.string.isRequired,
      manufacturer: PropTypes.string.isRequired,
      video_url: PropTypes.string,
    }),
  }),
};

DrugItem.defaultProps = {
  item: {
    days: '',
    recommendation: null,
    drug: { video_url: null },
  },
};

export default DrugItem;
